import {
  Icon as ChakraIcon,
  IconProps as CharkaIconProps,
} from '@chakra-ui/react';

export type IconProps = CharkaIconProps;
export const Icon = ChakraIcon;
